import { useLeafletContext } from '@react-leaflet/core'
import L from 'leaflet'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

export const DownloadController: React.FC<{ onClick?: (anchorEl: HTMLElement) => void }> = ({ onClick }) => {
  const { t } = useTranslation(['common'])
  const context = useLeafletContext()
  const container = context.layerContainer || context.map
  const controlRef = useRef<HTMLDivElement | null>(null)
  const olexDownload = new L.Control({ position: 'topright' })

  olexDownload.onAdd = function () {
    const div = L.DomUtil.create('div', 'leaflet-control')
    div.style.cssText = 'width:44px;height:44px;background:#fff;border-radius:4px;display:flex;align-items:center;justify-content:center;cursor:pointer;'
    div.innerHTML =
      '<img style="width:24px;height:24px;pointer-events:none;" src="//map.havbruksloggen.no/Content/icons/gzdl.png"/>'

    controlRef.current = div
    div.setAttribute('data-test-id', 'map-download-control')

    div.onclick = () => {
      if (onClick) {
        onClick(div)
      } else {
        toast(t('export-error'), { type: 'error' })
      }
    }
    return div
  }
  useEffect(() => {
    olexDownload.addTo(container as any)
  }, [])
  return <></>
}
